import { versioneExSituStore } from '../VersioneExSitu/store/VersioneExSitu.store';
import moment from 'moment';
import { printerHelper } from '../printer';
import { domainStore } from '../domains/store/domains.store';
import { areaSpecieProvenienzaStore } from '../AreaSpecieProvenienza/store/areaSpecieProvenienza.store';
import { usersStore } from '../Utenti/store/users.store';

export async function exportForm(source: server.PiantaSemeMarze, type: printer.type = printer.type.pdf): Promise<void> {
    let utenteCreatore = ["-- nessun creatore --"];
    const users = await usersStore.getters.getAll();
    
    if (source.userId) {
        const user = users.find(f => f.id.toLowerCase() === source.userId.toLowerCase());
        if(user) utenteCreatore = [`${user.firstName} ${user.lastName}`];
    }

    const printObj = [
        {
            header: "Dati Generali",
            data: {
                'Anno censimento': (await versioneExSituStore.getters.get(source.versioneId)).alias,
                'Area per specie/provenienza relazionata': (await areaSpecieProvenienzaStore.getters.get(source.areaSpecieProvenienzaId)).nome,
                'Codice pianta': source.codice ? source.codice : '',
                'Specie':  source.specie != null && source.specie != undefined ? (await domainStore.getters.specieArborea(source.specie))?.label : '',
                'Tipologia':  source.tipologia != null && source.tipologia != undefined ? (await domainStore.getters.tipoPiantaSemeMarze(source.tipologia))?.label : '',
                'Diametro': source.diametro || source.diametro==0 ? source.diametro.toFixed(1) + ' cm' : '',
                'Altezza': source.altezza || source.altezza==0 ? source.altezza.toFixed(1) + ' m' : '',
                'Attecchimento': source.attecchimento ? 'si' : 'no'
            }
        }, {
            header: "Altro",
            data: {
                'Note': source.note ? source.note : null,
                'Data rilievo': source.data ? moment(source.data).format("DD-MM-YYYY") : '',
                'Utente creatore della pianta': utenteCreatore,
            }
        } as printer.group
    ];
    printerHelper.print(type, source.codice, 'Pianta da Seme/da Marze', printObj);
}